/** Character entrance variants for {@link Ctextfx} — locked to the decrypt
 *  entrance, with Plain as the settled/no-entrance rendering. */
export enum CtextfxVariant {
  /** Settled text immediately — no entrance. */
  Plain = "Plain",
  /** Multi-origin bidirectional decrypt (scrambled glyphs resolve in place). */
  Decrypt = "Decrypt",
}

export const CTEXTFX_VARIANTS: readonly CtextfxVariant[] = [
  CtextfxVariant.Plain,
  CtextfxVariant.Decrypt,
];

export const DEFAULT_CTEXTFX_VARIANT = CtextfxVariant.Decrypt;

/** Default reveal throughput for Decrypt. */
export const DEFAULT_CTEXTFX_CHARS_PER_SECOND = 90;

/** Default per-letter scramble roll delay range (Decrypt). */
export const DEFAULT_CTEXTFX_SCRAMBLE_MIN_MS = 140;
export const DEFAULT_CTEXTFX_SCRAMBLE_MAX_MS = 480;

export const DEFAULT_CTEXTFX_DECRYPT_GLYPHS =
  "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
